import { PropsWithChildren } from "react";
import clsx from "clsx";

import { useIsUpdateBannerShown } from "@hooks/index";

export const PageContentContainer = ({ children }: PropsWithChildren) => {
  const isUpdateBannerHidden = useIsUpdateBannerShown();

  return (
    <div
      className={clsx(
        "mt-6 min-h-[calc(100dvh_-_288px)] rounded-t-2xl bg-white-100 px-4 pb-32 pt-4 md:rounded-b-lg md:rounded-t-3xl md:px-10 md:pb-8 md:pt-8",
        isUpdateBannerHidden
          ? "md:mt-8 md:min-h-[calc(100dvh_-_328px)]"
          : "md:mt-8 md:min-h-[calc(100dvh_-_384px)]",
      )}
    >
      {children}
    </div>
  );
};
